import { relations } from 'drizzle-orm'
import {
  boolean,
  index,
  integer,
  pgTable,
  text,
  timestamp,
  unique,
  uuid,
} from 'drizzle-orm/pg-core'
import { tenants } from './tenants'
import { trainings } from './training'

// Training Skill Items（研修ごとのスキルチェック項目マスター。code は不変で文言更新時も同一項目として扱う）
export const trainingSkillItems = pgTable(
  'training_skill_items',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    trainingId: uuid('training_id')
      .notNull()
      .references(() => trainings.id, { onDelete: 'cascade' }),
    code: text('code').notNull(),
    category: text('category').notNull(),
    label: text('label').notNull(),
    sortOrder: integer('sort_order').notNull().default(0),
    isActive: boolean('is_active').notNull().default(true),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id, { onDelete: 'cascade' }),
    createdAt: timestamp('created_at').defaultNow().notNull(),
    updatedAt: timestamp('updated_at').defaultNow().notNull(),
  },
  (table) => ({
    trainingCodeUnique: unique().on(table.trainingId, table.code),
    trainingIdIdx: index('training_skill_items_training_id_idx').on(table.trainingId),
    tenantIdIdx: index('training_skill_items_tenant_id_idx').on(table.tenantId),
  }),
)

export const trainingSkillItemsRelations = relations(trainingSkillItems, ({ one }) => ({
  training: one(trainings, {
    fields: [trainingSkillItems.trainingId],
    references: [trainings.id],
  }),
}))

export type TrainingSkillItem = typeof trainingSkillItems.$inferSelect
export type NewTrainingSkillItem = typeof trainingSkillItems.$inferInsert
